export default __webpack_public_path__ + "static/media/Asset 11.1be47765.png";